// extracted by mini-css-extract-plugin
export default {"rating":"NE-z","numberOfStars":"OE-z","count":"PE-z","barGraphSpacing":"QE-z","barGraph":"RE-z"};